import { Directive, HostListener, ElementRef } from "@angular/core";

@Directive({
    selector: "[focusFirstInvalidField]"
})
export class FocusFirstInvalidFieldDirective {

    constructor(private el: ElementRef) { }

    @HostListener("submit")
    onFormSubmit() {
        const invalidControl = this.el.nativeElement.querySelector(".ng-invalid");

        if (invalidControl) {
            setTimeout(() => {
                //invalidControl.querySelector("input")?.focus();

                invalidControl.querySelector("input") ? invalidControl.querySelector("input").focus() : invalidControl.querySelector("mat-select")?.focus();
            }, 200);
        }
    }
}